function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30,
  fill: "#00A783",
  fillRule: "nonzero",
  rx: 1.168
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.162 18.706a2.603 2.603 0 110 5.206 2.603 2.603 0 010-5.206zm10.412 0a2.603 2.603 0 110 5.206 2.603 2.603 0 010-5.206zM4.953.486a.87.87 0 01.835.626l4.167 14.39h13.157l1.351-3.738H12.658a.868.868 0 010-1.735h12.433l1.315-3.631H10.928a.869.869 0 110-1.735h16.716a.868.868 0 01.818 1.162l-3.922 10.84a.87.87 0 01-.818.573H9.301a.87.87 0 01-.836-.627L4.3 2.22h-2.68a.869.869 0 110-1.736h3.334z",
  fill: "#FFF",
  fillRule: "nonzero"
}));

function SvgIconCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCart);
export default __webpack_public_path__ + "static/media/icon-cart.7cf24397.svg";
export { ForwardRef as ReactComponent };